@if (viewModel$ | async; as current) {
    <ms-event-switcher-navigation [showHeader]="!isEpcotEnabled" [event]="event" [tree]="current" />
}
